module.exports = __webpack_public_path__ + "assets/img/Australian-Institute-of-Fitness-Website-w960.a7886e44.webp";